"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditRiskAssessmentReportFrequency = void 0;
const Field_type_1 = require("../../../types/Field.type");
const CreditRiskAssessmentReportFrequency_1 = require("../../enm/CreditRiskAssessmentReportFrequency");
exports.CreditRiskAssessmentReportFrequency = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.credit_risk_assessment_report_frequency.label',
    fallbackLabel: 'Do you report the results of your merchant risk assessment to any regulatory authorities, and how often do you need to report or undergo scrutiny by the mentioned authorities?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: CreditRiskAssessmentReportFrequency_1.CreditRiskAssessmentReportFrequencyRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
